import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import classnames from 'classnames'

import CustomIconButton from './CustomIconButton'
import { Card } from 'components/Card'

const ImageRatingButton = ({ isSelected, imgSrc, onClick, className }) => (
  <Card className={'!w-[60px] !h-[60px]'} active={isSelected} onClick={onClick} link>
    <div className="image">
      <img
        style={{ fontSize: '1rem', textAlign: 'center' }}
        className={classnames('ui image', className)}
        src={imgSrc}
        alt="No Icon"
      />
    </div>
  </Card>
)

ImageRatingButton.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  imgSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

/**
 *
 * @param {object} props
 * @param {number} props.iconSetId
 * @param {() => {}} props.onClick
 * @param {import('organisms/QuestionBuilderCard').IconSetOption[]} props.iconSetOptions
 * @param {string} props.defaultPreviewIconSetImageKey
 * @returns
 */
const ImageRatingButtonList = ({
  iconSetId,
  onClick,
  iconSetOptions,
  defaultPreviewIconSetImageKey,
}) => {
  return (
    <div className="!mt-1 ui cards">
      {iconSetOptions.map((iconSetOption, i) => {
        const DEFAULT_ICON_SET_IMAGE_URL =
          'https://cdn.simplesat.io/images/missing-icon-set-thumbnail.png'
        const imageSource =
          iconSetOption[defaultPreviewIconSetImageKey] || DEFAULT_ICON_SET_IMAGE_URL
        return (
          <ImageRatingButton
            key={i}
            isSelected={iconSetId === iconSetOption.id}
            imgSrc={imageSource}
            className="p2"
            onClick={R.partial(onClick, [iconSetOption])}
          />
        )
      })}
      <CustomIconButton />
    </div>
  )
}

ImageRatingButtonList.defaultProps = {
  onClick: () => {},
}

export default ImageRatingButtonList



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NewQuestion/ImageRatingButtonList.js